import React from 'react'
import Intro from '../components/Intro'
import Main from '../components/main/Main'

const Home = () => {
  return (
    <div className='Home  '>
        <Intro/>
        <Main/>
    </div>
  )
}

export default Home